<template>
  <div style="width:100%">
    <Header title="" type="login"></Header>
    <div class="banner">
      <div class="stylebanner1" id="bannerMobile1"></div>
    </div>
    <div class="form">
      <input class="hide" id="username" name="username" type="text" />
      <input class="hide" id="password" name="password" type="password" />
      <div class="formitem">
        <input
          autocomplete="off"
          :placeholder="$t('m.PlsEnterMobileEmailLoginName')"
          style="border:none;outline:none"
          v-model.trim="value1"
        />
        <span @click="value1=''" class="icon" v-if="value1">
          <Icon class="color" type="ios-close-circle" />
        </span>
      </div>
      <div class="formitem">
        <input
          :type="bool?'password':'text'"
          @input="change()"
          autocomplete="off"
          :placeholder="$t('m.PlsEnterPass')"
          style="border:none;outline:none"
          v-model.trim="value2"
        />
        <span @click="booldo" class="icon" v-if="value2">
          <Icon class="color" type="ios-eye" v-if="bool"></Icon>
          <Icon class="color" type="ios-eye-off" v-if="!bool"></Icon>
        </span>
      </div>
      <div :class="{bgc:(value1&&value2),button:true}" @click="sub">{{$t('m.Login')}}</div>
      <div class="help">
        <router-link class="left" tag="span" to="/register">{{$t('m.QuickRegister')}}</router-link>
        <router-link class="right" tag="span" to="/forgetpassword">{{$t('m.ForgetPass')}}</router-link>
      </div>
      <div class="logo">
        <div class="stylebanner2" id="bannerMobile2"></div>
      </div>
    </div>
  </div>
</template>
<script>
import Header from "../header/header";
import { changeskin,getEntSettingInfo,login } from "../../assets/js/url";

export default {
  name: "login",
  data() {
    return {
      value1: "",
      value2: "",
      bool: false
    };
  },
  components: {
    Header
  },
  activated() {
	this.getEntSettingInfo();  
	if (window.localStorage.getItem("loginName")) {
      this.value1 = window.localStorage.getItem("loginName");
    }
    if (window.localStorage.getItem("password")) {
      if (this.check()) {
        // this.resetoldtime()
      } else {
        window.localStorage.removeItem("password");
      }
    }
    if (window.localStorage.getItem("password")) {
      this.value2 = window.localStorage.getItem("password");
    }
    if (
      window.localStorage.getItem("loginName") &&
      window.localStorage.getItem("password")
    ) {
      this.sub();
    }
  },
  methods: {
    booldo() {
      this.bool = false;
      const _this = this;
      setTimeout(function() {
        _this.bool = true;
      }, 3000);
    },
    getnowtime() {
      const time = new Date();
      return time.getTime();
    },
    resetoldtime() {
      window.localStorage.setItem("oldtime", this.getnowtime());
    },
    getoldtime() {
      return window.localStorage.getItem("oldtime");
    },
    check() {
      if (!this.getoldtime()) {
        return false;
      }
      return this.getnowtime() - this.getoldtime() < 1000 * 60 * 60 * 24 * 30;
    },
    change() {
      this.bool = true;
    },
	getEntSettingInfo() {
		this.$http.get(getEntSettingInfo, {})
        .then(res => {
            window.localStorage.setItem('pageTitle', res.data.data.pageTitle);
		    window.localStorage.setItem('bannerMobile', res.data.data.bannerMobile);
		    
			document.title = window.localStorage.getItem("pageTitle")?window.localStorage.getItem("pageTitle"):'';
			document.getElementById("bannerMobile1").style.background = 'url('+window.localStorage.getItem("bannerMobile")+') center center no-repeat';
			document.getElementById("bannerMobile2").style.background = 'url('+window.localStorage.getItem("bannerMobile")+') center center no-repeat';
			document.getElementById("bannerMobile1").style.backgroundSize = '100% 100%';
			document.getElementById("bannerMobile2").style.backgroundSize = '100% 100%';
        });
	},
    sub() {
      if (!this.value1 || !this.value2) {
        return;
      }
      window.localStorage.setItem("loginName", this.value1);
      window.localStorage.setItem("password", this.value2);
      const data = {
        loginName: this.value1,
        loginPassword: this.value2,
        flat: 2,
        usertype: 2
      };
      this.$loadingshow();
      this.$http.post(login, data).then(
        res => {
          this.$loadingclose();
          if (res.data.status == 2000) {
            window.sessionStorage.setItem(
              "Time",
              res.data.data.sync_now_meeting_each_seconds
            );
            // window.sessionStorage.setItem("Admin",res.data.data.admin_level)
            this.$store.commit("setusemessage", res.data.data);
            this.resetoldtime();
            this.value1 = "";
            this.value2 = "";
            if (res.data.data.state == "2") {
              this.$toast(this.$t('m.NoPermission'));
              return;
            }
            window.sessionStorage.setItem("UUID", res.data.data.useruuid); //将uuid设置到本地缓存中
            window.sessionStorage.setItem('userID', res.data.data.userID);
            window.sessionStorage.setItem(
              "userStatus",
              res.data.data.admin_level
            );
            if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
              window.sessionStorage.setItem(
                "downUrl",
                res.data.data.endpoint_software_ios_download_url
              );
            } else if (/(Android)/i.test(navigator.userAgent)) {
              window.sessionStorage.setItem(
                "downUrl",
                res.data.data.endpoint_software_andriod_download_url
              );
            }
            window.sessionStorage.setItem("flat", "2"); //普通平台=2
            window.sessionStorage.setItem("login", "mobile"); //区分微信登陆还是一般登陆
			window.sessionStorage.setItem('JSESSIONID', res.data.data.sid);
            this.$http
              .post(changeskin, {
                useruuid: res.data.data.useruuid,
                action: 1,
                color: 1
              })
              .then(skin => {
                if (skin.data.status == 2000) {
                  const num = skin.data.data.customer_color;
                  const style =
                    num == 1
                      ? "green"
                      : num == 2
                      ? "blue"
                      : num == 3
                      ? "grep"
                      : num == 4
                      ? "black"
                      : "blcak";
                  this.$store.commit("changestyle", style);
                }
              });
            this.$router.push({ path: "/index" });
          } else {
            this.$toast(res.data.data.errorDes);
          }
        },
        err => {}
      );
      //
    }
  }
};
</script>
<style scoped>
.banner {
  margin-top: 0.3rem;
  width: 100%;
  height: 0.48rem;
  text-align: center;
}

.banner img {
  width: 2.3rem;
}

.form {
  margin: 0.7rem 0.3rem 0.2rem;
  height: 1.5rem;
  position: relative;
}

.hide {
  width: 0;
  height: 0;
  position: absolute;
  opacity: 0;
  top: -200px;
  left: 0;
}

.formitem {
  width: 100%;
  height: 0.5rem;
  background-color: #f6f7fa;
  border-radius: 3px;
  margin-top: 6px;
  box-sizing: border-box;
  padding: 0 0.15rem;
}

.formitem input {
  height: 0.5rem;
  width: 2.5rem;
  background-color: transparent;
  border: none;
  outline: none;
}

.formitem input:visited {
  border: none;
}

.formitem input:focus {
  border: none;
}

.formitem input:active {
  border: none;
}

.button {
  width: 100%;
  height: 0.44rem;
  background-color: #bec9bc;
  border-radius: 3px;
  margin-top: 0.2rem;
  box-sizing: border-box;
  padding: 0 0.15rem;
  text-align: center;
  line-height: 0.44rem;
  font-size: 0.16rem;
  color: #fff;
}

.left {
  color: #989696;
  font-size: 0.14rem;
  float: left;
}

.right {
  color: #989696;
  font-size: 0.14rem;
  float: right;
}

.help {
  width: 100%;
  height: 0.5rem;
  line-height: 0.5rem;
}

.logo {
  margin-top: 1rem;
  width: 100%;
  height: 0.26rem;
  text-align: center;
}

.logo img {
  width: 1.01rem;
  height: 0.26rem;
}

i {
  font-size: 0.2rem;
  vertical-align: middle;
}

.icon {
  height: 0.5rem;
  line-height: 0.5rem;
  float: right;
}
</style>




// WEBPACK FOOTER //
// src/components/login/login.vue